import { getSupabase } from '@/systems/SupabaseClient';

/**
 * RankingService — leaderboard público pseudônimo.
 *
 * Chama a função SQL `top_students(limit_count)` (SECURITY DEFINER, ver
 * migration 0002). Devolve só apelido + XP + posição — sem qualquer
 * PII. RLS de student_progress não é flexibilizada; toda a leitura
 * cruzada acontece dentro da função.
 */

export interface RankingEntry {
  position: number;
  displayName: string;
  totalXP: number;
}

export type RankingResult<T> = { ok: true; value: T } | { ok: false; error: string };

const DEFAULT_LIMIT = 20;
const MAX_LIMIT = 100;

export async function getTopStudents(limit = DEFAULT_LIMIT): Promise<RankingResult<RankingEntry[]>> {
  const safeLimit = Math.max(1, Math.min(MAX_LIMIT, Math.floor(limit)));
  const { data, error } = await getSupabase().rpc('top_students', { limit_count: safeLimit });
  if (error) return { ok: false, error: error.message };
  // SQL devolve a coluna como `place` (POSITION é palavra reservada);
  // mapeamos pra `position` no shape exposto.
  const rows = (data ?? []) as Array<{ place: number; display_name: string; total_xp: number }>;
  return {
    ok: true,
    value: rows.map((r) => ({
      position: r.place,
      displayName: r.display_name,
      totalXP: r.total_xp,
    })),
  };
}
